import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { setErrorPanel } from '../../redux/utilities/utils.actions';
import {
	verifyOTP,
	sendOTP,
	setShowVerifyMob,
} from '../../redux/profile/profile.actions';
import Modal from 'react-bootstrap/Modal';

const VerifyMobile = ({
	phone,
	setErrorMsg,
	error: { panelClass, panelMsg },
	verifyOTP,
	sendOTP,
	isOtpSent,
	setShowVerifyMob,
	showVerifyMob,
}) => {
	const [otp, setOtp] = useState('');
	useEffect(() => {
		if (isOtpSent) {
			setErrorMsg({
				panelClass: 'alert alert-success',
				panelMsg: 'OTP sent successfully.',
			});
		} else {
			setErrorMsg({
				panelClass: '',
				panelMsg: '',
			});
		}
	}, [isOtpSent, setErrorMsg]);

	const submit = (e) => {
		//check for type, close on success and change number feature
		e.preventDefault();
		if (otp === '') {
			setErrorMsg({
				panelClass: 'alert alert-danger',
				panelMsg: 'Please enter OTP.',
			});
		} else {
			setErrorMsg({
				panelClass: '',
				panelMsg: '',
			});
			verifyOTP(otp);
		}
	};

	const resendOTP = () => {
		setErrorMsg({
			panelClass: '',
			panelMsg: '',
		});
		setOtp('');
		document.getElementById('otp').value = '';
		sendOTP(phone);
	};
	return (
		<Modal
			show={showVerifyMob}
			dialogClassName="modal-90w"
			onHide={() => {
				setShowVerifyMob(false);
			}}
			backdrop="static"
			keyboard={false}
		>
			<Modal.Header
				closeButton
			>{`Enter OTP sent to mobile number ${phone}`}</Modal.Header>
			<Modal.Body size="lg">
				<div className={panelClass}>{panelMsg}</div>
				<form>
					<div className="form-group">
						<label
							className="text-left"
							style={{ display: 'inline-block', float: 'left' }}
						>
							Enter OTP:
						</label>

						<input
							type="text"
							className="form-control"
							name="otp"
							id="otp"
							placeholder="OTP*"
							defaultValue={otp}
							onChange={(e) => {
								setOtp(e.target.value);
							}}
							onBlur={(e) => {
								setOtp(e.target.value);
							}}
						/>
					</div>
					<span>
						OTP not received?
						<span className="divAsAnchor" onClick={resendOTP}>
							Request Another OTP
						</span>
					</span>
					<div className="form-group ">
						<button
							aria-label="generate"
							id="button"
							type="submit"
							value="test"
							className="btn btn-primary"
							onClick={(e) => {
								submit(e);
							}}
						>
							Verify
						</button>
					</div>
				</form>
			</Modal.Body>
		</Modal>
	);
};

const mapStateToProps = (state) => {
	const { profileDetails, utils } = state.rootReducer;
	return {
		//	phone: userDetails.phone,
		error: utils.errorPanel,
		isOtpSent: profileDetails.isOtpSent,
		showVerifyMob: profileDetails.showVerifyMob,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		sendOTP: (val) => dispatch(sendOTP(val)),
		verifyOTP: (val) => dispatch(verifyOTP(val)),
		setShowVerifyMob: (val) => dispatch(setShowVerifyMob(val)),
		// generateCertificate: (val) => dispatch(generateCertificate(val)),
		setErrorMsg: (obj) => dispatch(setErrorPanel(obj)),
	};
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
	VerifyMobile,
);
